<template>
  <div class="CompanyProfile">
    <div class="CompanyProfile-top">
      <div class="product">
        <div class="product-cont">
          <div class="product-box">
            <img class="companyprofile-bg" src="../../../../static/image/companyprofile-bg.png" alt="">
            <div class="CompanyProfile-box">
              <div class="CompanyProfile-title">{{ info.title }}</div>
              <div class="CompanyProfile-cont">
                <div v-html="info.desc"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="CompanyProfile-bottom">
      <div class="product">
        <div class="product-cont">
          <div class="product-box">
            <div class="establish">
              <div class="left flex-box">
                <div class="establish-text">{{details.title}}</div>
                <div class="establish-day">{{details.year}}</div>
              </div>
              <div class="right flex-box">
                <div class="establish-list" v-for="(item, index) in details.event" :key="index">
                  <span class="establish-r"></span> {{ item.content }}
                </div>
              </div>
            </div>
            <div class="swiperlist">
              <div class="swipers">
                <div class="swiper-container">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(item, index) in superurl" :key="index">
                      <div>
                        <div class="step-line"></div>
                        <div class="step-content">
                          <div class="step-num" @click="getSwiper(item)">{{ item.year }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="swiper-button-prev">
                  <i class="el-icon-arrow-left" color="#FFFFFF"></i>
                </div>
                <div class="swiper-button-next">
                  <i class="el-icon-arrow-right" color="#FFFFFF"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
import { aboutList } from '@/request/api'
export default {
  props: {
    productId: {
      typeof: String,
      required: true,

    }
  },
  data() {
    return {
      info: {},
      details:{},
      superurl: [
        {
          url: "",
          img: "2002"
        },
        {
          url: "",
          img: "2003"
        },
        {
          url: "",
          img: "2004"
        },
        {
          url: "",
          img: "2005"
        },
        {
          url: "",
          img: "2006"
        },
        {
          url: "",
          img: "2007"
        },
        {
          url: "",
          img: "2020"
        }
      ]
    }
  },
  created() {
    this.getList()
  },
  mounted() {
     this.info = JSON.parse(localStorage.getItem("info")).company_desc
  },
  methods: {
    getList() {
      aboutList({ channel: 40}).then(res => {
        if (res.code == 1) {
          this.details = res.data.list[0]
          this.superurl = res.data.list
          new Swiper(".swiper-container", {
            slidesPerView: 6, //显示三个轮播
            // centeredSlides: true, //设定为true时，active slide会居中，而不是默认状态下的居左。
            // centerInsufficientSlides: true, //开启这个参数，当slides的总数小于slidesPerView时，slides居中。不适用于loop模式和slidesPerColumn
            // centeredSlidesBounds: true, //使得第一个和最后一个Slide 始终贴合边缘。
            // loop: true, //循环
            // autoplay: true, //自动播放
            // direction: "vertical", //竖屏
            breakpoints: {
                768: {
                    slidesPerView: "3",
                },
            },
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
          });
        }
      })
    },
    getSwiper(item){
      this.details = item
    },
  }
}
</script>
<style lang="scss" scoped>
.CompanyProfile-top {
  position: relative;
}

.companyprofile-bg {
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: -1;
}

.CompanyProfile-title {
  font-size: 36px;
  text-align: center;
  font-family: Arial-Bold, Arial;
  font-weight: bold;
  color: #333333;
}

.CompanyProfile-cont {
  margin-top: 43px;
  font-size: 16px;
  color: #666;
  line-height: 30px;
}

.CompanyProfile-bottom {
  background-image: url('../../../../static/image/aboutus-botom.png');
  width: 100%;
  background-size: 100% 100%;

  .establish-text {
    font-size: 46px;
    font-family: Arial-Bold, Arial;
    font-weight: bold;
    color: #FFFFFF;
  }

  .establish-day {
    margin-top: 26px;
    width: 140px;
    height: 45px;
    text-align: center;
    line-height: 45px;
    background: #DB2733;
    font-size: 26px;

    color: #FFFFFF;
  }

  .establish {
    display: flex;
    align-items: self-start;

    .flex-box {
      width: 50%;

      .establish-list {
        margin-bottom: 35px;
        font-size: 18px;

        color: #FFFFFF;
      }

      .establish-r {
        border-radius: 100%;
        display: inline-block;
        width: 11px;
        height: 11px;
        background: #FFFFFF;
        opacity: 0.91;
        margin-right: 17px;
      }
    }
  }
}

.swiperlist {
  margin: 0 auto;
  margin-top: 200px;
  position: relative;
  width: 80%;


  .swiper-slide {
    display: flex;
    justify-content: center;

    .step-num {
      cursor: pointer;
      margin-top: 18px;
      font-size: 24px;

      color: #FFFFFF;
    }
  }

  >>>.swiper-button-next,
  .swiper-button-prev {
    // display: none;
    background: none !important;
    background-image: none !important;
    transform: rotate(0deg);
    color: #FFFFFF;
  }

  // /deep/.swiper-button-prev:after {
  //   display: none;
  // }
}

.step-line {
  margin-left: 30px;
  width: 14px;
  height: 14px;
  border-radius: 100%;
  background: #FFFFFF;
  position: relative;
}

.step-line::before {
  display: inline-block;
  position: absolute;
  width: 215px;
  height: 1px;
  right: 0;
  left: 14px;
  top: 7px;
  z-index: 100;
  content: '';
  border-top: 1px dashed #FFFFFF;
}

.swiper-button-prev,
.swiper-container-rtl .swiper-button-next {
  left: -10%;
  right: 0;
  top: 15px;
  color: #3a70ca;
}

.swiper-button-next,
.swiper-container-rtl .swiper-button-prev {
  top: 15px;
  right: -10%;
  color: #3a70ca;
}

.swiper-button-next:after,
.swiper-button-prev:after {
  font-size: 25px;
}

@media screen and (max-width:767px) {
  .establish{
    display: block !important;
    .flex-box{
      width: 100% !important;
    }
    .right{
      margin-top: 30px;
    }

  }
  .swiperlist{
      margin-top: 30px !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/view/aboutUs/components/CompanyProfile.vue